import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import BOTGuidedNavigation from './BOTGuidedNavigation'
import { setFiltersData, removeFiltersData } from '../../actions'

export default compose(
  withType({
    type: 'BOTGuidedNavigation',
    placeholders: ['navigation']
  }),
  connect(null, { setFiltersData, removeFiltersData }),
  lifecycle({
    componentDidMount() {
      this.props.setFiltersData(this.props)
    },

    componentDidUpdate() {
      this.props.setFiltersData(this.props)
    },

    componentWillUnmount() {
      this.props.removeFiltersData(this.props)
    }
  })
)(BOTGuidedNavigation)
